<template>
  <el-dialog :visible.sync="dialogVisible" width="1200px" custom-class="combo-meal-dialog"
    :close-on-click-modal="false">
    <template #title>
      <div class="header-container">
        <span>套餐开单详情</span>
        <PrescriptionListPopver />
      </div>
    </template>
    <div class="content-wrapper">
      <div class="left-section">
        <!-- 热门套餐套装 -->
        <div class="popular-packages">
          <div class="section-title">套餐列表</div>
          <el-input size="mini" v-model="packageName" clearable placeholder="请输入名称">
            <el-button size="mini" slot="append" icon="el-icon-search" @click="getPackageList"></el-button>
          </el-input>
          <div class="packages-grid">
            <div v-for="item in popularPackages" :key="item.id" class="package-card"
              :class="{ active: selectedPackage.PackageId === item.PackageId }" @click="selectPackage(item)">
              <div class="package-name">{{ item.PackageName }}</div>
              <div class="package-price">¥{{ item.TotalAmount }}</div>
              <div class="package-desc">{{ item.PPRemark }}</div>
            </div>
            <el-empty v-if="popularPackages.length === 0" description="没有套餐数据"></el-empty>
          </div>
        </div>
      </div>
      <div class="middle-section">
        <div class="package-detail">
          <div class="section-title">当前选择的套餐：{{ selectedPackage.PackageName }}</div>
          <div class="step-wrapper">
            <el-steps :active="stepIndex" finish-status="success" simple>
              <el-step title="确认套餐商品"></el-step>
              <el-step title="确认开单"></el-step>
            </el-steps>
          </div>
          <div class="detail-table" v-loading="loading" element-loading-text="数据加载中...">
            <el-carousel style="height: 100%;" v-if="dialogVisible" indicator-position="none" :initial-index="stepIndex" :autoplay="false"
              arrow="never" ref="tableCarousel">
              <!-- 套餐内容 -->
              <el-carousel-item style="height: 100%;" >
                <table>
                  <thead>
                    <tr>
                      <th style="text-align: center;">类别</th>
                      <th style="text-align: center;">商品</th>
                      <th style="text-align: center;">库存</th>
                      <th style="text-align: center;">数量</th>
                      <th style="text-align: center;">单价</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in selectedPackageDetails" :key="index">
                      <td>
                        <el-tag size="mini">{{ categoryKeys[row.ProductType] || '---' }}</el-tag>
                      </td>
                      <td>
                        <el-select filterable size="mini" v-model="row.ProductId"
                          @change="handleProductChange($event, row)">
                          <el-option v-for="item in row.ProductItems" :key="item.ProductId" :value="item.ProductId"
                            :label="`${item.Brand.BrandName}-${item.ProductName}`"></el-option>
                        </el-select>
                        <el-tooltip v-if="row.ProductItems.length === 0 && row.ProductName" class="item" effect="dark"
                          :content="`【${row.ProductName}】- 未上架`" placement="top-start">
                          <i class="el-icon-warning-outline" style="color: red;"></i>
                        </el-tooltip>
                      </td>
                      <td>{{ row.inventory }}</td>
                      <td>
                        {{ row.PPDCount }}
                      </td>
                      <td style="color: red">¥ {{ row.PPDPrice }}</td>
                    </tr>
                  </tbody>
                  <!-- 空数据 -->
                  <tr v-if="selectedPackageDetails.length === 0">
                    <td colspan="6">
                      <el-empty description="暂无数据~~~"></el-empty>
                    </td>
                  </tr>
                </table>
              </el-carousel-item>
              <!-- 购物车 -->
              <el-carousel-item style="height: 100%;" >
                <table>
                  <thead>
                    <tr>
                      <th style="text-align: center;">类别</th>
                      <th style="text-align: center;">商品</th>
                      <th style="text-align: center;">用法</th>
                      <th style="text-align: center;">库存</th>
                      <th style="text-align: center;">数量</th>
                      <th style="text-align: center;">单价</th>
                      <th style="text-align: center;">总价</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in cartList" :key="index">
                      <td>
                        <el-tag size="mini">{{ categoryKeys[row.CHPProductSortGroup] || '---' }}</el-tag>
                      </td>
                      <td>
                        {{ row.ProductRelation.ShopProduct.ProductName }}
                      </td>
                      <td>
                        <MedicationPopover v-if="row.CHPProductSortGroup === 'drug'" :product-id="row.CHPProductId"
                          :model="row.drugModel" @success="handleDrugSuccess($event, row)" />
                        <RelatedPrescriptionPopover v-else-if="row.CHPProductSortGroup === 'lens'" :model="row"
                          @success="(item) => row = item" />
                        <OklensPrescriptionPopover v-else-if="row.CHPProductSortGroup === 'oklens'" :model="row"
                          @success="(item) => row = item" />
                        <span v-else>---</span>
                      </td>
                      <td>有货</td>
                      <td>
                        {{ row.CHPAmount }}
                      </td>
                      <td style="color: red">¥ {{ row.price }}</td>
                      <td style="color: red">¥ {{ row.price * row.CHPAmount }}</td>
                    </tr>
                  </tbody>
                  <!-- 空数据 -->
                  <tr v-if="cartList.length === 0">
                    <td colspan="6">
                      <el-empty description="暂无数据~~~"></el-empty>
                    </td>
                  </tr>
                </table>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :loading="submitLoading" @click="handleCancel">{{ stepIndex === 1 ? '上一步' : '放弃操作' }}</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleConfirm">{{ stepIndex === 0 ? '确认下一步' : '立即开单'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getPackageListApi, getPackageDetailApi, getCartListApi, deleteCartProductApi, batchAddCartApi, submitOrderApi, updateCartProductApi } from '../api'
import MedicationPopover from './medication-popver.vue';
import { categoryKeys } from '../data/keys'
import RelatedPrescriptionPopover from './related-prescription-popver.vue';
import PrescriptionListPopver from './prescription-list-popver.vue';
import OklensPrescriptionPopover from './oklens-prescription-popver.vue';
export default {
  name: 'ComboMealModal',
  model: {
    prop: "show",
    event: "change",
  },
  inject: ['chooseId', 'expertId', 'customerId', 'companyId', 'shopId', 'userId'],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MedicationPopover,
    RelatedPrescriptionPopover,
    PrescriptionListPopver,
    OklensPrescriptionPopover
  },
  data() {
    return {
      submitLoading: false,
      categoryKeys,
      loading: false,
      packageName: '',
      stepIndex: 0,
      selectedPackage: {},
      popularPackages: [],
      selectedPackageDetails: [],
      cartList: [],
    };
  },
  methods: {
    decoding(json) {
      if (!json) {
        return "";
      }
      let str = json;
      str = str.replace(/\*\*\*/g, '"');
      str = JSON.parse(str);
      return str;
    },
    conversionJson(json) {
      if (!json) {
        return "";
      }
      let str = JSON.stringify(json);
      str = str.replace(/"/g, "***");
      return str;
    },
    // 更新购物车产品
    async updateCartProduct(row) {
      try {
        await updateCartProductApi(row);
      } catch (error) {
        console.log(error)
      }
    },
    // 药品信息更新
    handleDrugSuccess(item, row) {
      row.CHPPrescriptionData = this.conversionJson(item);
      row.CHPLeftRightEyes = item.LeftOrRight;
      this.updateCartProduct(row)
    },
    // 获取套餐列表
    async getPackageList() {
      try {
        const res = await getPackageListApi({
          ShopId: this.shopId,
          PackageName: this.packageName
        });
        this.popularPackages = res.data?.Result || [];
        if (this.popularPackages.length) {
          this.selectedPackage = this.popularPackages[0];
        } else {
          this.selectedPackage = {};
          this.selectedPackageDetails = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取套餐详细
    async getPackageDetail(PackageId) {
      if (!PackageId) {
        this.selectedPackageDetails = [];
        return;
      };
      try {
        this.loading = true;
        const res = await getPackageDetailApi({ PackageId, ShopId: this.shopId });
        const list = res.data?.Result?.DetailItem || [];
        this.selectedPackageDetails = list?.map(item => ({
          ...item,
          ProductId: item.ProductItems?.length ? item.ProductItems?.[0]?.ProductId : '',
          // 库存
          inventory: item.ProductItems?.length ? item.ProductItems?.[0]?.Amount : 0,
          ProductName: item.ProductItems?.length ? item.ProductItems?.[0]?.ProductName : item.ProductName,
          PPDPrice: item.ProductItems?.length ? item.ProductItems?.[0]?.ProductOfficalPrice : 0,
        }));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 套餐商品改变
    handleProductChange(value, row) {
      const find = row.ProductItems.find((item) => item.ProductId === value);
      if (find) {
        row.inventory = find.Amount;
        row.ProductName = find.ProductName;
        row.PPDPrice = find.ProductOfficalPrice;
      }
    },
    // 获取购物车列表
    async getCartList() {
      try {
        this.loading = true;
        const { data } = await getCartListApi({
          ShopId: this.shopId,
          ChooseId: this.chooseId
        });
        this.cartList = data?.GetListResult?.map(item => {
          const CHPPrescriptionData = item.CHPPrescriptionData;
          const price = this.selectedPackageDetails.find(p => p.ProductId === item.CHPProductId)?.PPDPrice;
          const drugModel = {
            Drug_Days: '',
            Drug_UseMethod: '',
            Drug_CountPerDay: '',
            Drug_TimeInDay: '',
            LeftOrRight: '',
            Drug_CountPerTime: '',
          }
          return {
            ...item,
            price,
            drugModel: CHPPrescriptionData ? this.decoding(CHPPrescriptionData) : drugModel,
          }
        }) || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 选择套餐
    async selectPackage(item) {
      if (this.stepIndex === 1) return;
      this.selectedPackage = item;
    },
    // 清空购物车
    async clearCart() {
      for (const item of this.cartList) {
        await deleteCartProductApi(item.ChooseProductId);
      }
      this.cartList = [];
    },
    // 上一步或者关闭
    async handleCancel() {
      try {
        if (this.stepIndex === 1) {
          this.submitLoading = true;
          this.stepIndex--;
          this.$refs.tableCarousel?.prev();
        } else {
          this.dialogVisible = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.submitLoading = false;
      }
    },
    // 下一步或者开单提交
    async handleConfirm() {
      if (this.stepIndex === 0) {
        for (const item of this.selectedPackageDetails) {
          if (!item.ProductId) {
            this.$message.error("您有未确认套餐商品没有选择~");
            return;
          }
          // if (!item.inventory) {
          //   this.$message.error(`【${item.ProductName}】-库存不足`);
          //   return;
          // }
        }
        this.submitLoading = true;
        // 获取记录购物车列表
        await this.getCartList();
        // 清空购物车
        await this.clearCart();
        // 批量加入购物车
        const list = this.selectedPackageDetails?.map(item => ({
          CHPChooseId: this.chooseId,
          CHPProductId: item.ProductId,
          CHPAmount: item.PPDCount,
          CHPPrice: item.PPDPrice * item.PPDCount,
          CHPProductSortGroup: item.ProductType,
          CHPExpertId: this.expertId,
          CHPProductSource: 'package'
        }))
        await batchAddCartApi(list);
        this.$refs.tableCarousel?.next();
        this.stepIndex++;
        await this.getCartList();
        this.submitLoading = false;
        return;
      }
      for (const item of this.cartList) {
        if (item.CHPProductSortGroup === 'lens' && !item.CHPS_OP_ALL_Id) {
          this.$message.error(`未绑定商品-【${item.ProductRelation.ShopProduct.ProductName}】-处方数据`);
          return;
        }
        if (item.CHPProductSortGroup === 'drug' && !item.CHPPrescriptionData) {
          this.$message.error(`未选择药品-【${item.ProductRelation.ShopProduct.ProductName}】-用法说明`);
          return;
        }
        if (item.CHPProductSortGroup === 'drug' && !item?.drugModel?.LeftOrRight) {
          this.$message.error(`未选择药品-【${item.ProductRelation.ShopProduct.ProductName}】-左右眼`);
          return;
        }
      }
      const ListCustomerOrderDetail = this.cartList?.map(item => {
        const price = this.selectedPackageDetails.find(p => p.ProductId === item.CHPProductId)?.PPDPrice;
        return {
          CODProductId: item.CHPProductId,
          CODShopId: this.shopId,
          CODCompanyId: this.companyId,
          CODExpertId: this.expertId,
          CODData: item.CODData,
          CODEyeExamId: item.CHPS_OP_ALL_Id,
          CODProductSortKey: item.CHPProductSortGroup,
          CODAmount: item.CHPAmount,
          CODLeftRight: item.CHPLeftRightEyes,
          CODPrice: price,
          CODTotalPrice: price * item.CHPAmount,
          CODSinglePrice: price,
          CODSingleTotalPrice: price * item.CHPAmount,
          CODCHPId: item.ChooseProductId,
          CODGroup: 'A组'
        }
      });
      const data = {
        COCustomerId: this.customerId,
        COShopId: this.shopId,
        COCompanyId: this.companyId,
        COChooseId: this.chooseId,
        COExpertId: this.expertId,
        COAddUserId: this.userId,
        CODes: '套餐开单',
        COPrice: this.selectedPackage.TotalAmount,
        COTotalPrice: this.selectedPackage.TotalAmount,
        COAddress: '',
        COPayState: 'order',
        COrderType: this.cartList?.map(item => item.CHPProductSortGroup).join(','),
        ListCustomerOrderDetail: ListCustomerOrderDetail,
      }
      this.$confirm('确定要开单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '提交中...';
            try {
              const res = await submitOrderApi(data);
              if (!res.data?.COrderId) {
                this.$message.error(res.data?.Msg);
              } else {
                this.$emit('success', res?.data?.RetURL);
                done();
              }
            } catch (error) {
              console.log(error);
            } finally {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = '确认';
            }
          } else {
            done();
          }
        }
      }).then(() => {
        this.$message.success('开单成功');
        this.dialogVisible = false;
      }).catch(() => { });
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('change', val);
      }
    }
  },
  watch: {
    dialogVisible(newV) {
      if (newV) {
        this.getPackageList();
      } else {
        this.stepIndex = 0;
        this.selectedPackage = {};
        this.packageName = '';
      }
    },
    // 深度监听 selectedPackage
    selectedPackage: {
      handler(newV) {
        this.getPackageDetail(newV?.PackageId);
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../styles/modal.scss';
</style>